import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@material-ui/core';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useLocation } from 'react-router-dom';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Select from 'react-select'; // Import react-select

const SaleReturnEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);
    const location = useLocation();
    const [storeLocationOptions, setStoreLocationOptions] = useState([]);
    const [selectedStoreLocation, setSelectedStoreLocation] = useState(null);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);

    //Bank
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBanks = async () => {
        try {
            const response = await fetchData('PaymentApi', `/Banks/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Bank:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
            CompanyId: companyId,
            BankId: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchBanks();
    }, []);

    useEffect(() => {
        fetchData('SaleReturnApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setSelectedItems(response.response_data.SaleDetails);

                    setSelectedBank({
                        value: response.response_data.Sale.BankId,
                        label: response.response_data.Sale.BankName
                    });

                    if (response.response_data.Sale.StoreLocationId) {
                        setSelectedStoreLocation({
                            value: response.response_data.Sale.StoreLocationId,
                            label: response.response_data.Sale.StoreLocationName,
                        });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    useEffect(() => {
        fetchBranchData();
        fetchDropdownSalesManOptions();
        fetchfrightrate();
        fetchStoreLocations();
    }, []);

    const fetchStoreLocations = () => {
        fetchData('StoreLocationApi', `/${companyId}`, token)
            .then((res) => {
                if (res.responseCode === '1111') setStoreLocationOptions(res.response_data);
            })
            .catch((err) => console.error('Error fetching store locations:', err));
    };

    const fetchfrightrate = () => {
        fetchData('CompanyApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    FreightGSTRate: data[0].FreightGSTRate,
                    PackingGSTRate: data[0].FreightGSTRate,
                }));
                setdefaultFreightGSTRate(data[0].FreightGSTRate);
                setdefaultPackingGSTRate(data[0].FreightGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
            });
    };

    const fetchBranchData = () => {
        fetchData('BranchApi', `/BranchDetails/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    DispatchFrom: data.CompanyName,
                    DispatchAddress1: data.AddressLine1,
                    DispatchAddress2: data.AddressLine2,
                    DispatchLocation: data.Location,
                    DispatchPincode: data.PinCode,

                    TransporterName: data.TransporterName,
                    TransporterGST: data.GSTNumber,
                }));

            })
            .catch((error) => {
                console.error('Error Dispatch Deatils', error);
            });
    };

    //FOR GET InvoicetypeData  Details FROM API
    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleReturnApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    // // Helper function to parse and handle NaN values as 0
    // const parseAndFix = (val) => parseFloat(val) || 0;


    // const calculateItemData = (item, formData) => {
    //     let rate = parseAndFix(item.Rate);
    //     let quantity = parseAndFix(item.Quantity);
    //     let cgstRate = parseAndFix(item.GSTRate) / 2;
    //     let sgstRate = parseAndFix(item.GSTRate) / 2;
    //     let Discper = parseAndFix(item.DiscountPercentage);
    //     let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
    //     let totdiscount = parseFloat(Addidiscamt);
    //     let grate = (rate - totdiscount).toFixed(2);
    //     let amt = (quantity * rate).toFixed(2);
    //     let amount = (quantity * grate).toFixed(2);
    //     let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

    //     if (formData.InvoiceTypeId === 3) {
    //         igstAmount = ((amount * (cgstRate + sgstRate)) / 100).toFixed(2);
    //     } else {
    //         cgstAmount = ((amount * cgstRate) / 100).toFixed(2);
    //         sgstAmount = ((amount * sgstRate) / 100).toFixed(2);
    //     }

    //     let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
    //     let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
    //     setdefaultFreightGSTRate(defaultFreightGST);
    //     setdefaultPackingGSTRate(defaultPackingGST);

    //     const totalAmount = parseAndFix(amount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

    //     return {
    //         ...item,
    //         Amount: amt,
    //         DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
    //         TaxableAmount: amount,
    //         CGSTAmount: cgstAmount,
    //         SGSTAmount: sgstAmount,
    //         IGSTAmount: igstAmount,
    //         TotalAmount: totalAmount.toFixed(2),

    //     };
    // };


    // const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

    //     let freightGSTRate = parseAndFix(formData.FreightGSTRate);
    //     let packingGSTRate = parseAndFix(formData.PackingGSTRate);
    //     freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
    //     packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));
    //     let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
    //     let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

    //     let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
    //     let roundOff = Math.round(netAmount) - netAmount;
    //     let grandTotal = netAmount + roundOff;
    //     let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

    //     setFormData((prev) => ({
    //         ...prev,
    //         TotalQuantity: Quantity,
    //         TotalAmount: Amount.toFixed(2),
    //         TaxableAmount: TaxableAmount.toFixed(2),
    //         CGSTAmount: CGSTAmount.toFixed(2),
    //         SGSTAmount: SGSTAmount.toFixed(2),
    //         IGSTAmount: IGSTAmount.toFixed(2),
    //         RoundOff: roundOff.toFixed(2),
    //         GrandTotal: grandTotal.toFixed(2),
    //         BalanceAmount: balhamt.toFixed(2),
    //         DiscountAmount: DiscountAmount.toFixed(2),
    //         FreightGSTAmount: freightGSTAmount,
    //         PackingGSTAmount: packingGSTAmount,
    //         ModifiedBy: userId,
    //         FreightGSTRate: freightGSTRate,
    //         PackingGSTRate: packingGSTRate,
    //     }));
    // };

    // // Calculation
    // const handleCalculation = (e, index, inputType) => {
    //     let name, value;
    //     if (typeof e === 'object') {
    //         name = e.target.name;
    //         value = e.target.value;
    //     } else {
    //         name = inputType;
    //         value = e;
    //     }

    //     // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
    //     setSelectedItems((prevDetails) => {

    //         const updatedDetails = [...prevDetails];
    //         const currentItem = { ...updatedDetails[index], [name]: value };

    //         // Update the item in the copied array
    //         updatedDetails[index] = currentItem;

    //         const updatedItemData = updatedDetails.map((item) => calculateItemData(item, formData));

    //         const totals = updatedItemData.reduce(
    //             (acc, item) => {
    //                 acc.Quantity += parseAndFix(item.Quantity);
    //                 acc.Amount += parseAndFix(item.Amount);
    //                 acc.DiscountAmount += parseAndFix(item.DiscountAmount);
    //                 acc.TaxableAmount += parseAndFix(item.TaxableAmount);
    //                 acc.CGSTAmount += parseAndFix(item.CGSTAmount);
    //                 acc.SGSTAmount += parseAndFix(item.SGSTAmount);
    //                 acc.IGSTAmount += parseAndFix(item.IGSTAmount);
    //                 acc.TotalAmount += parseAndFix(item.TotalAmount);

    //                 return acc;
    //             },
    //             { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
    //         );

    //         const FreightAmount = parseAndFix(formData.FreightAmount);
    //         const PackingAmount = parseAndFix(formData.PackingAmount);
    //         const TCSAmount = parseAndFix(formData.TCSAmount);
    //         let CashAmount = parseAndFix(formData.CashAmount) || 0;
    //         let CardAmount = parseAndFix(formData.CardAmount) || 0;
    //         let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

    //         totalCalculation(
    //             totals.Quantity,
    //             totals.Amount,
    //             totals.DiscountAmount,
    //             totals.TaxableAmount,
    //             totals.CGSTAmount,
    //             totals.SGSTAmount,
    //             totals.IGSTAmount,
    //             totals.TotalAmount,
    //             FreightAmount,
    //             PackingAmount,
    //             TCSAmount,
    //             CashAmount,
    //             CardAmount,
    //             UPIAmount,
    //         );

    //         return updatedItemData;
    //     });
    // };

    // const handleChange = (event) => {
    //     const { name, value, type, checked } = event.target;

    //     // Immediate update of the input field
    //     let updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

    //     // Validation and adjustment for CardAmount, UPIAmount, and CashAmount
    //     if (['CardAmount', 'UPIAmount', 'CashAmount'].includes(name)) {
    //         const grandTotal = parseFloat(formData.GrandTotal || 0);
    //         const otherAmounts = {
    //             CardAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.UPIAmount || 0),
    //             UPIAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.CardAmount || 0),
    //             CashAmount: parseFloat(formData.CardAmount || 0) + parseFloat(formData.UPIAmount || 0),
    //         };

    //         // Calculate the maximum allowed value for the current field
    //         const maxAllowed = grandTotal - otherAmounts[name];

    //         // Ensure the entered value does not exceed the maxAllowed
    //         updatedValue = Math.min(parseFloat(updatedValue || 0), maxAllowed);
    //     }

    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: updatedValue,
    //     }));

    //     if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'CashAmount', 'CardAmount', 'UPIAmount'].includes(name)) {
    //         // Use the value directly for the calculation to avoid relying on stale state
    //         updateFormDataAndDetails(name, updatedValue);
    //     }
    // };

    // const updateFormDataAndDetails = (key, value) => {
    //     // const fixedValue = parseAndFix(value).toFixed(2);
    //     const fixedValue = parseAndFix(value);

    //     // Update the formData with the new value
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [key]: fixedValue,
    //         ModifiedBy: userId,
    //     }));

    //     // Use the updated value for calculations
    //     const updatedFormData = {
    //         ...formData,    // current form data
    //         [key]: fixedValue  // the newly updated value
    //     };

    //     // Recalculate invoice details using the latest form data
    //     const updatedItemData = selectedItems.map((item) => calculateItemData(item, updatedFormData));
    //     setSelectedItems(updatedItemData);

    //     // Calculate totals based on the updated invoice details
    //     const totals = calculateTotals(updatedItemData);

    //     // Dynamically get the values from the updated form data
    //     const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

    //     // Fetch the latest values for calculations               
    //     const TCSAmount = dynamicValue('TCSAmount');
    //     const FreightAmount = dynamicValue('FreightAmount');
    //     const PackingAmount = dynamicValue('PackingAmount');
    //     let CashAmount = dynamicValue('CashAmount');
    //     let CardAmount = dynamicValue('CardAmount');
    //     let UPIAmount = dynamicValue('UPIAmount');
    //     // Perform the final total calculation
    //     totalCalculation(
    //         totals.Quantity,
    //         totals.Amount,
    //         totals.DiscountAmount,
    //         totals.TaxableAmount,
    //         totals.CGSTAmount,
    //         totals.SGSTAmount,
    //         totals.IGSTAmount,
    //         totals.TotalAmount,
    //         FreightAmount,
    //         PackingAmount,
    //         TCSAmount,
    //         CashAmount,
    //         CardAmount,
    //         UPIAmount,
    //     );
    // };

    // // Utility function to calculate totals
    // const calculateTotals = (updatedItemData) => {
    //     return updatedItemData.reduce(
    //         (acc, item) => {
    //             acc.Quantity += parseAndFix(item.Quantity);
    //             acc.Amount += parseAndFix(item.Amount);
    //             acc.TaxableAmount += parseAndFix(item.TaxableAmount);
    //             acc.DiscountAmount += parseAndFix(item.DiscountAmount);
    //             acc.CGSTAmount += parseAndFix(item.CGSTAmount);
    //             acc.SGSTAmount += parseAndFix(item.SGSTAmount);
    //             acc.IGSTAmount += parseAndFix(item.IGSTAmount);
    //             acc.TotalAmount += parseAndFix(item.TotalAmount);
    //             return acc;
    //         },
    //         { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
    //     );
    // };



      const parseAndFix = (val) => parseFloat(val) || 0;
    

    // FOR Calculation
    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

        let freightGSTRate = parseAndFix(formData.FreightGSTRate);
        let packingGSTRate = parseAndFix(formData.PackingGSTRate);
        freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
        packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));

        let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
        let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

        let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;
        let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            GrandTotal: grandTotal.toFixed(2),
            BalanceAmount: balhamt.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            FreightGSTAmount: freightGSTAmount,
            PackingGSTAmount: packingGSTAmount,
            ModifiedBy: userId,
            FreightGSTRate: freightGSTRate,
            PackingGSTRate: packingGSTRate,
        }));
    };


    // Calculation
    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
        setSelectedItems((prevDetails) => {

            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index], [name]: value };

            // Update the item in the copied array
            updatedDetails[index] = currentItem;

            const updatedItemData = updatedDetails.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.CashAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );

            return updatedItemData;
        });
    };

    const calculateItemData = (item, formData) => {

        // Decide which rate to use
        let baseRate = formData.IsWholeSaleRate
            ? parseAndFix(item.WholeSaleRate)   // <-- Wholesale Rate field
            : parseAndFix(item.SaleRate ?? item.Rate); // <-- Fallback to SaleRate or Rate

        let rate = parseAndFix(baseRate);
        let quantity = parseAndFix(item.Quantity);
        let cgstRate = parseAndFix(item.GSTRate) / 2;
        let sgstRate = parseAndFix(item.GSTRate) / 2;
        let Discper = parseAndFix(item.DiscountPercentage);
        let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
        let totdiscount = parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let amt = (quantity * rate).toFixed(2);

        let salerate = (grate / (1 + (cgstRate + sgstRate) / 100)).toFixed(2);
        let amount = (quantity * salerate).toFixed(2);

        //let amount = (quantity * grate).toFixed(2);
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.InvoiceTypeId === 3 || formData.InvoiceTypeId == 4) {
            igstAmount = ((amount * (cgstRate + sgstRate)) / 100).toFixed(2);
        } else {
            cgstAmount = ((amount * cgstRate) / 100).toFixed(2);
            sgstAmount = ((amount * sgstRate) / 100).toFixed(2);
        }

        let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
        let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
        setdefaultFreightGSTRate(defaultFreightGST);
        setdefaultPackingGSTRate(defaultPackingGST);

        const totalAmount = parseAndFix(amount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

        return {
            ...item,
            Amount: amt,
            Rate: rate.toFixed(2),
            DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
            TaxableAmount: amount,
            CGSTAmount: cgstAmount,
            SGSTAmount: sgstAmount,
            IGSTAmount: igstAmount,
            TotalAmount: totalAmount.toFixed(2),

        };
    };

    //handle change
    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        let updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        // Validation and adjustment for CardAmount, UPIAmount, and CashAmount
        if (['CardAmount', 'UPIAmount', 'CashAmount'].includes(name)) {
            const grandTotal = parseFloat(formData.GrandTotal || 0);
            const otherAmounts = {
                CardAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.UPIAmount || 0),
                UPIAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.CardAmount || 0),
                CashAmount: parseFloat(formData.CardAmount || 0) + parseFloat(formData.UPIAmount || 0),
            };

            // Calculate the maximum allowed value for the current field
            const maxAllowed = grandTotal - otherAmounts[name];

            // Ensure the entered value does not exceed the maxAllowed
            updatedValue = Math.min(parseFloat(updatedValue || 0), maxAllowed);
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));

        if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'CashAmount', 'CardAmount', 'UPIAmount', 'InvoiceTypeId'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        // const fixedValue = parseAndFix(value).toFixed(2);
        const fixedValue = parseAndFix(value);

        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue  // the newly updated value
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = selectedItems.map((item) => calculateItemData(item, updatedFormData));
        setSelectedItems(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations               
        const TCSAmount = dynamicValue('TCSAmount');
        const FreightAmount = dynamicValue('FreightAmount');
        const PackingAmount = dynamicValue('PackingAmount');
        let CashAmount = dynamicValue('CashAmount');
        let CardAmount = dynamicValue('CardAmount');
        let UPIAmount = dynamicValue('UPIAmount');
        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totals.DiscountAmount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            FreightAmount,
            PackingAmount,
            TCSAmount,
            CashAmount,
            CardAmount,
            UPIAmount,
        );
    };
    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            BankId: selectedBank ? selectedBank.value : null, // Save BankId
        }));


        const CreateData = {
            Sale: formData,
            SaleDetails: selectedItems
        };

        // Validate form data here if needed

        updateData('SaleReturnApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/SaleReturnIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = selectedItems.filter((_, i) => i !== itemToDeleteIndex);
            setSelectedItems(updatedItemList);
            closeConfirmDialog();
        }
    };

    const [itemsOptions, setItemsrOptions] = useState([]);
    const handleItemChange = (newValue) => newValue;
    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }

        const customerid = formData.MasterId !== null ? formData.MasterId : 0;
        try {
            // Fetch data from the API
            const response = await fetchData('SaleReturnApi', `/Item/${companyId}/${branchId}/${customerid}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;
                setItemsrOptions(data);
                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    //// modalData 
    // FOR MODEL DATA (Invoice Details)
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName1: '',
        ItemId: '',
        Quantity: '',
        Rate: '',
        Amount: '',
        TaxableAmount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
    });

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const shouldReload = localStorage.getItem('shouldReload') === 'true';

        if (location.state?.from === '/SaleReturnIndex' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
    }, [location]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen((prev) => !prev);
    };


    // ── Color tokens ──
    const GN  = "#1a7a4a";
    const GNL = "#e8f5ee";
    const GND = "#155d38";

    // ── Shared input styles ──
    const inp = {
        border: "1px solid #d1d5db", borderRadius: "4px", fontSize: "12px",
        height: "30px", width: "100%", padding: "0 8px", outline: "none",
        backgroundColor: "#fff", boxSizing: "border-box", color: "#1a2e2e"
    };
    const inpRO = { ...inp, backgroundColor: "#f8fafa", cursor: "default" };
    const inpR  = { ...inp, textAlign: "right" };
    const inpROR = { ...inpRO, textAlign: "right" };
    const lbl = { fontSize: "10px", color: "#6b7280", display: "block", marginBottom: "2px", fontWeight: 500 };

    // ── Section styles ──
    const sectionBox  = { backgroundColor: "#fff", border: "1px solid #e5e7eb", borderRadius: "6px", marginBottom: "8px", overflow: "hidden" };
    const sectionHead = { backgroundColor: GNL, borderBottom: `2px solid ${GN}`, padding: "5px 12px" };
    const sectionTitle = { fontSize: "11px", fontWeight: 700, color: GND, textTransform: "uppercase", letterSpacing: "0.5px" };

    return (
        <div style={{ fontFamily: "Segoe UI, sans-serif", fontSize: "12px", width: "100%", padding: "6px", boxSizing: "border-box", backgroundColor: "#f5f5f5" }}>

            {/* ── Top action bar ── */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px", gap: "8px" }}>
                <span style={{ fontWeight: 700, fontSize: "13px", color: GN }}>Sale Return Edit</span>

                <div style={{ display: "flex", gap: "8px" }}>
                    <button
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{ height: "30px", padding: "0 16px", borderRadius: "4px", border: "none", backgroundColor: GN, color: "#fff", fontWeight: 600, fontSize: "12px", cursor: isLoading ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: "4px" }}
                    >
                        {isLoading ? <CircularProgress size={14} color="inherit" /> : null}
                        Update
                    </button>
                    <Link
                        to="/SaleReturnIndex"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{ height: "30px", padding: "0 14px", borderRadius: "4px", border: "1px solid #d1d5db", backgroundColor: "#fff", color: "#374151", fontWeight: 600, fontSize: "12px", cursor: "pointer", display: "flex", alignItems: "center", textDecoration: "none" }}
                    >
                        ← Back
                    </Link>
                </div>
            </div>

            {errorMessage && <p style={{ color: "#ef4444", marginBottom: "8px", fontSize: "12px" }}>{errorMessage}</p>}

            {/* ══ SECTION 1 — Sale Return Information ══ */}
            <div style={sectionBox}>
                <div style={sectionHead}><span style={sectionTitle}>Sale Return Information</span></div>
                <div style={{ padding: "8px 12px", display: "flex", gap: "10px", alignItems: "flex-end", flexWrap: "wrap" }}>
                    <div style={{ flex: "1 1 200px" }}>
                        <label style={lbl}>Customer <span style={{ color: "#6b7280" }}>| Invoice: {formData.InvoiceTypeName}</span></label>
                        <input type="text" name="CustomerName" value={formData.CustomerName || ""} readOnly style={inpRO} />
                    </div>
                    <div style={{ flex: "0 0 130px" }}>
                        <label style={lbl}>Sale Bill No</label>
                        <input type="text" name="SaleBillNumber" value={formData.SaleBillNumber || ""} readOnly style={inpRO} />
                    </div>
                    <div style={{ flex: "0 0 130px" }}>
                        <label style={lbl}>Sale Bill Date</label>
                        <input type="date" name="SaleBillDate" value={formatDateForInput(formData.SaleBillDate)} readOnly style={inpRO} />
                    </div>
                    <div style={{ flex: "0 0 130px" }}>
                        <label style={lbl}>Sale RTN Date</label>
                        <input type="date" name="BillDate" value={formatDateForInput(formData.BillDate)} onChange={handleChange} style={inp} />
                    </div>
                    <div style={{ flex: "0 0 140px" }}>
                        <label style={lbl}>Sale RTN Number</label>
                        <input type="text" name="BillNumber" value={`${formData.BillPrefix || ''}/${formData.BillNumber || ''}/${formData.FinYear || ''}`} readOnly style={inpRO} />
                    </div>
                    {/* Store Location */}
                    <div style={{ flex: "0 0 180px" }}>
                        <label style={lbl}>Store Location</label>
                        <Select
                            options={storeLocationOptions.map((s) => ({ value: s.Id, label: s.Name }))}
                            value={selectedStoreLocation}
                            onChange={(selected) => {
                                setSelectedStoreLocation(selected);
                                setFormData((prev) => ({ ...prev, StoreLocationId: selected ? selected.value : null }));
                            }}
                            isClearable isSearchable placeholder="Store Location"
                            menuPortalTarget={document.body}
                            styles={{
                                control: (b) => ({ ...b, minHeight: "30px", height: "30px", fontSize: "12px", borderColor: "#d1d5db", borderRadius: "4px", boxShadow: "none" }),
                                valueContainer: (b) => ({ ...b, height: "30px", padding: "0 8px" }),
                                indicatorsContainer: (b) => ({ ...b, height: "30px" }),
                                menuPortal: (b) => ({ ...b, zIndex: 3000 }),
                                menu: (b) => ({ ...b, fontSize: "12px" }),
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* ══ SECTION 2 — Sale Return Items ══ */}
            <div style={sectionBox}>
                <div style={{ ...sectionHead, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "6px" }}>
                    <span style={sectionTitle}>Sale Return Items ({filteredData.length} items)</span>
                    <input
                        type="text"
                        placeholder="Search items..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ height: "24px", border: "1px solid #d1d5db", borderRadius: "4px", fontSize: "11px", padding: "0 8px", outline: "none", width: "160px" }}
                    />
                </div>
                <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                    {filteredData.length === 0 ? (
                        <div style={{ backgroundColor: GNL, padding: "20px", textAlign: "center", fontSize: "12px", color: GND }}>No items found</div>
                    ) : (
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                            <thead style={{ backgroundColor: GN, color: "#fff", position: "sticky", top: 0 }}>
                                <tr>
                                    {["#", "Item", "S.Qty", "R.Qty", "Rate", "Amount", "Disc%", "Disc Amt", "Taxable", "GST%", "GST Amt", "Total", ""].map((h, i) => (
                                        <th key={i} style={{ padding: "6px 4px", textAlign: i > 1 ? "right" : "left", fontSize: "10px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.4px", whiteSpace: "nowrap" }}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((item, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#fff" : GNL, borderBottom: "1px solid #e5e7eb" }}>
                                        <td style={{ padding: "3px 6px", textAlign: "center", whiteSpace: "nowrap" }}>{index + 1}</td>
                                        <td style={{ padding: "3px 4px", minWidth: "160px", fontWeight: 600 }}>{item.ItemName}</td>
                                        <td style={{ padding: "2px", width: "70px" }}>
                                            <input type="number" value={item.SaleQuantity || 0} readOnly style={{ ...inpROR, height: "24px", borderRadius: "4px" }} />
                                        </td>
                                        <td style={{ padding: "2px", width: "70px" }}>
                                            <input
                                                type="number"
                                                value={item.Quantity || 0}
                                                name="Quantity"
                                                min="0"
                                                max={item.SaleQuantity}
                                                onClick={(e) => e.target.select()}
                                                onChange={(e) => {
                                                    const newValue = parseInt(e.target.value, 10);
                                                    if (newValue <= item.SaleQuantity) {
                                                        handleCalculation(e, index, 'Quantity');
                                                    }
                                                }}
                                                style={{ ...inpR, height: "24px", borderRadius: "4px", backgroundColor: GNL }}
                                            />
                                        </td>
                                        <td style={{ padding: "2px", width: "100px" }}>
                                            <input type="number" value={item.Rate || 0} name="Rate" onChange={(e) => handleCalculation(e, index, "Rate")} style={{ ...inpR, height: "24px", borderRadius: "4px" }} />
                                        </td>
                                        <td style={{ padding: "2px", width: "100px" }}>
                                            <input value={item.Amount || 0} readOnly style={{ ...inpROR, height: "24px", borderRadius: "4px" }} />
                                        </td>
                                        <td style={{ padding: "2px", width: "80px" }}>
                                            <input type="number" value={item.DiscountPercentage || 0} name="DiscountPercentage" onChange={(e) => handleCalculation(e, index, "DiscountPercentage")} style={{ ...inpR, height: "24px", borderRadius: "4px" }} />
                                        </td>
                                        <td style={{ padding: "2px", width: "90px" }}>
                                            <input value={item.DiscountAmount || 0} readOnly style={{ ...inpROR, height: "24px", borderRadius: "4px" }} />
                                        </td>
                                        <td style={{ padding: "2px", width: "100px" }}>
                                            <input value={item.TaxableAmount || 0} readOnly style={{ ...inpROR, height: "24px", borderRadius: "4px" }} />
                                        </td>
                                        <td style={{ padding: "3px 4px", textAlign: "right", whiteSpace: "nowrap", fontSize: "11px", color: "#6b7280" }}>
                                            {item.GSTRate ? parseFloat(item.GSTRate) : 0}%
                                        </td>
                                        <td style={{ padding: "2px", width: "90px" }}>
                                            <input value={(parseFloat(item.CGSTAmount || 0) + parseFloat(item.SGSTAmount || 0) + parseFloat(item.IGSTAmount || 0)).toFixed(2)} readOnly style={{ ...inpROR, height: "24px", borderRadius: "4px" }} />
                                        </td>
                                        <td style={{ padding: "2px", width: "100px" }}>
                                            <input value={item.TotalAmount || 0} readOnly style={{ ...inpROR, height: "24px", borderRadius: "4px", fontWeight: 700, color: GND }} />
                                        </td>
                                        <td style={{ padding: "2px", textAlign: "center", width: "30px" }}>
                                            <DeleteIcon
                                                style={{ color: "#ef4444", cursor: "pointer", fontSize: "16px", verticalAlign: "middle" }}
                                                onClick={() => openConfirmDialog(index)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>

            {/* ══ SECTION 3 — Bottom: Additional Charges + Summary ══ */}
            <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
                <div style={{ ...sectionBox, flex: "1 1 0", marginBottom: 0 }}>
                    <div style={sectionHead}><span style={sectionTitle}>Additional Charges</span></div>
                    <div style={{ padding: "10px 12px" }}>
                        <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                            <div style={{ flex: "1 1 0" }}>
                                <label style={lbl}>Freight <span style={{ color: "#6b7280" }}>({formData.FreightGSTRate}% GST: {formData.FreightGSTAmount})</span></label>
                                <input type="number" name="FreightAmount" value={formData.FreightAmount || 0} onChange={handleChange} style={inpR} />
                            </div>
                            <div style={{ flex: "1 1 0" }}>
                                <label style={lbl}>Packing <span style={{ color: "#6b7280" }}>({formData.PackingGSTRate}% GST: {formData.PackingGSTAmount})</span></label>
                                <input type="number" name="PackingAmount" value={formData.PackingAmount || 0} onChange={handleChange} style={inpR} />
                            </div>
                            <div style={{ flex: "1 1 0" }}>
                                <label style={lbl}>TCS Amount</label>
                                <input type="number" name="TCSAmount" value={formData.TCSAmount || 0} onChange={handleChange} style={inpR} />
                            </div>
                            <div style={{ flex: "1 1 0" }}>
                                <label style={lbl}>Cash Amount</label>
                                <input type="number" name="CashAmount" value={formData.CashAmount || 0} onChange={handleChange} min="0"
                                    max={Math.max(0, parseFloat(formData.GrandTotal || 0) - (parseFloat(formData.CardAmount || 0) + parseFloat(formData.UPIAmount || 0)))}
                                    style={{ ...inpR, fontWeight: 700, color: "#059669" }} />
                            </div>
                            <div style={{ flex: "1 1 0" }}>
                                <label style={lbl}>UPI Amount</label>
                                <input type="number" name="UPIAmount" value={formData.UPIAmount || 0} onChange={handleChange} min="0"
                                    max={Math.max(0, parseFloat(formData.GrandTotal || 0) - (parseFloat(formData.CashAmount || 0) + parseFloat(formData.CardAmount || 0)))}
                                    style={{ ...inpR, fontWeight: 700, color: "#059669" }} />
                            </div>
                            <div style={{ flex: "1 1 0" }}>
                                <label style={lbl}>Card Amount</label>
                                <input type="number" name="CardAmount" value={formData.CardAmount || 0} onChange={handleChange} min="0"
                                    max={Math.max(0, parseFloat(formData.GrandTotal || 0) - (parseFloat(formData.CashAmount || 0) + parseFloat(formData.UPIAmount || 0)))}
                                    style={{ ...inpR, fontWeight: 700, color: "#059669" }} />
                            </div>
                            <div style={{ flex: "1 1 0" }}>
                                <label style={lbl}>Credit Amount</label>
                                <input type="text" name="BalanceAmount" value={formData.BalanceAmount || 0} readOnly
                                    style={{ ...inpR, fontWeight: 700, color: parseFloat(formData.BalanceAmount) > 0 ? "#ef4444" : "#1a2e2e", backgroundColor: parseFloat(formData.BalanceAmount) > 0 ? "#fef2f2" : "#f8fafa" }} />
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end" }}>
                            <div style={{ flex: "5 1 0" }}>
                                <label style={lbl}>Remarks</label>
                                <input type="text" name="Remarks" value={formData.Remarks || ""} onChange={handleChange} style={inp} />
                            </div>
                            {(formData.UPIAmount > 0 || formData.CardAmount > 0) && (
                                <div style={{ flex: "1 1 0" }}>
                                    <label style={lbl}>Bank</label>
                                    <Select
                                        value={selectedBank || { value: "", label: "Select Bank" }}
                                        onChange={handleBankChange}
                                        options={bankOptions}
                                        placeholder="Select Bank"
                                        isSearchable
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: "30px", height: "30px", fontSize: "12px", borderColor: "#d1d5db" }),
                                            valueContainer: (base) => ({ ...base, height: "30px", padding: "0 8px" }),
                                            indicatorsContainer: (base) => ({ ...base, height: "30px" }),
                                            menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                                            menu: (provided) => ({ ...provided, fontSize: "12px" }),
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div style={{ ...sectionBox, width: "200px", flexShrink: 0, marginBottom: 0 }}>
                    <div style={sectionHead}><span style={sectionTitle}>Summary</span></div>
                    <div style={{ padding: "8px 12px" }}>
                        {[
                            ["Subtotal", formData.TotalAmount, false],
                            ["Discount", formData.DiscountAmount, true],
                            ["Taxable", formData.TaxableAmount, false],
                            ["CGST", formData.CGSTAmount, false],
                            ["SGST", formData.SGSTAmount, false],
                            ["IGST", formData.IGSTAmount, false],
                            ["TCS", formData.TCSAmount, false],
                            ["Round Off", formData.RoundOff, false],
                        ].map(([label, val, isDiscount]) => (
                            <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0", borderBottom: "1px solid #f3f4f6", fontSize: "11px" }}>
                                <span style={{ color: "#6b7280" }}>{label}</span>
                                <span style={{ color: isDiscount ? "#ef4444" : "#1a2e2e", fontWeight: 700, fontSize: "12px" }}>{isDiscount ? "- " : ""}₹{parseFloat(val || 0).toFixed(2)}</span>
                            </div>
                        ))}
                        <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 0 2px 0", borderTop: `2px solid ${GN}`, marginTop: "2px" }}>
                            <span style={{ fontSize: "12px", fontWeight: 700, color: GND }}>Total</span>
                            <span style={{ fontSize: "13px", fontWeight: 700, color: GN }}>₹{parseFloat(formData.GrandTotal || 0).toFixed(2)}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirm Delete Dialog */}
            {confirmDialogOpen && (
                <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
                    <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "20px", width: "300px", boxShadow: "0 4px 20px rgba(0,0,0,0.2)" }}>
                        <p style={{ fontSize: "13px", marginBottom: "16px", color: "#374151" }}>Are you sure you want to delete this item?</p>
                        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                            <button onClick={closeConfirmDialog} style={{ padding: "6px 14px", borderRadius: "4px", border: "1px solid #d1d5db", backgroundColor: "#fff", cursor: "pointer", fontSize: "12px" }}>Cancel</button>
                            <button onClick={handleDelete} style={{ padding: "6px 14px", borderRadius: "4px", border: "none", backgroundColor: "#ef4444", color: "#fff", cursor: "pointer", fontSize: "12px", fontWeight: 600 }}>Delete</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default SaleReturnEdit;